import { graphql } from '../graphql';

export const startSurfaceDifference = graphql(`
  mutation StartSurfaceDifference($input: StartSurfaceDifferenceInput!) {
    startSurfaceDifference(input: $input)
  }
`);

export const surfaceDifferenceJobsQuery = graphql(`
  query SurfaceDifferenceJobs($projectId: ID!) {
    surfaceDifferenceJobs(projectId: $projectId) {
      id
      status
      label
      batchId
      inputJson
      outputJson
      errorLogs
      createdAt
      startedAt
      completedAt
    }
  }
`);
